import React, { memo } from 'react';
import { ChatMessage, User } from '@app/models';
import { dateFormat, fullName } from '@app/helpers';
import { ProfileAvatar } from 'pages/Profile/components';

interface Props {
  message: ChatMessage;
  user: User;
}

function Message(props: Props) {
  const { message, user } = props;

  const author = () => {
    if (message.authorCompany) {
      return message.authorCompany.name;
    }
    return fullName(message.authorUser);
  };

  const avatarFiles = () => {
    if (message.authorCompany) {
      return message.authorCompany.avatarFilesIds?.split(',')[0] || '';
    }
    return message.authorUser.avatarFilesIds?.split(',')[0] || '';
  };

  const isAuthor = message.authorUserId === user.id;

  return (
    <div className="w-full px-4 py-2">
      <div
        className={`flex items-end gap-2 max-w-[80%] ${
          isAuthor ? 'ml-auto flex-row-reverse' : 'mr-auto flex-row'
        }`}
      >
        <div className="flex-shrink-0">
          <ProfileAvatar size={40} avatarFiles={avatarFiles()} />
        </div>

        <div
          className={`flex flex-col ${isAuthor ? 'items-end' : 'items-start'}`}
        >
          <div
            className={`flex flex-col p-3 gap-1 rounded-2xl max-w-full ${
              isAuthor
                ? 'bg-primary text-primary-foreground rounded-br-md'
                : 'bg-accent text-secondary-foreground rounded-bl-md'
            }`}
          >
            <span
              className={`font-medium text-xs truncate ${
                isAuthor
                  ? 'text-primary-foreground/70'
                  : 'text-muted-foreground'
              }`}
            >
              {author()}
            </span>
            <span className="text-sm break-words whitespace-pre-line leading-relaxed">
              {message.message}
            </span>
          </div>
          <span
            className={`text-xs text-muted-foreground mt-1 px-1 ${
              isAuthor ? 'text-right' : 'text-left'
            }`}
          >
            {dateFormat(message.createdAt, 'HH:mm')}
          </span>
        </div>
      </div>
    </div>
  );
}

export default memo(Message);
